module.exports = __webpack_public_path__ + "assets/img/Logo_Paycell-L.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Logo_Paycell-L.png
// module id = 71
// module chunks = 0